import { ShopFeatureType } from '../../enums/shop-feature-type.enum'
import { IShop } from '../../interfaces/shop.interface'

export interface ShopsStateModel {
  shop: IShop
  allShops: IShop[]
  allShopsFeatures: Record<string, ShopFeatureType[]>
  organizationShops: IShop[]
}
